import '../css/SummerCamp.scss';
import summerCampFlyer from '../assets/summer-camp-2026.jpg';

const FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSeYDZ5uBwDQ2OwtYv5qxZTCQwpP9ScpMN68sJM0FKxQtqtM7g/viewform?usp=header';

const SummerCamp = () => (
  <section className="summer-camp-section">
    <div className="page-width summer-camp-inner">
      <div className="summer-camp-text">
        <span className="summer-kicker">Coming This August</span>
        <h2>HoneyRock Summer Camp 2026</h2>
        <p>
          A fun-filled, faith-inspired summer experience for children ages 2–11. Explore STEM &amp;
          AI, Entrepreneurship, Great Outdoors, and Creative Arts — all in one unforgettable month.
        </p>
        <ul className="summer-highlights">
          <li><strong>Dates:</strong> Aug 3 – 28, 2026 &nbsp;|&nbsp; 9:00 AM – 2:00 PM</li>
          <li><strong>Ages:</strong> 2 – 11 years</li>
          <li><strong>Weekly Track:</strong> ₦21,000 &nbsp;|&nbsp; <strong>Monthly Track:</strong> ₦75,000</li>
          <li><strong>Early Bird (15% off):</strong> Register by July 24, 2026</li>
        </ul>
        <a
          href={FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="summer-cta"
        >
          Register Now — Secure Your Spot
        </a>
      </div>
      <div className="summer-camp-flyer">
        <img src={summerCampFlyer} alt="HoneyRock Summer Camp 2026 flyer" />
      </div>
    </div>
  </section>
);

export default SummerCamp;
